import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError, change } from 'redux-form'
import { fetchCustomers } from '../actions/customers'
import LoadingProgress from '../components/LoadingProgress'
import ErrorMessage from '../components/ErrorMessage'

import Box from '../components/Box'
import { addPDA } from '../actions/pdas'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'

class PDAAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    };

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { fetchCustomers } = this.props

    fetchCustomers()
  }

  submit(props) {
    return this.props.addPDA(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { customers, error, pristine, submitting, handleSubmit } = this.props

    if (!customers) {
      return (
        <LoadingProgress />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">NUEVA </span>
          <span className="text-vw-light">PDA</span>
        </h1>
        <hr className="bg-vw-light" />
        <div className="row">
          <div className="col col-12 col-xs-12 col-md-4">
          </div>
          <div className="col col-12 col-xs-12 col-md-4">
            <Box title="Configuración" icon="cubes">
              <Field name="Customer"
                component={renderSelectField}
                label="Cliente">
                <option value="">Selecciona un cliente...</option>
                {customers &&
                  customers
                    .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                    .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                    .map((customer) => (
                      <option value={customer._id} key={customer._id}>
                        {customer.Fullname}
                      </option>
                    ))}
              </Field>
              <Field
                name="Token"
                type="text"
                label="SN Dispositivo"
                component={renderInputField}
              />
            </Box>
          </div>
          <div className="col col-12 col-xs-12 col-md-4">
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <button className="btn bg-vw-light text-white mr-1 save" type="submit"
          disabled={pristine || submitting}>
          Guardar
        </button>
      </form>
    )
  }
}

PDAAddForm = reduxForm({
  form: 'PDAAddForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/pdas/${result.response._id}`)
  }
})(PDAAddForm)

const mapStateToProps = state => ({
  customers: state.customers.customers
})

const mapDispatchToProps = dispatch => ({
  addPDA: bindActionCreators(addPDA, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PDAAddForm)

